function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import { injectIntl } from 'react-intl';
import './MoveModal.css';
import uuid from '../../../../utils/uuid';
import normalizeLocaleData from '../../../../utils/i18n/normalizeLocaleData';
import compose from '../../../../utils/compose';
import en from './locales/MoveModal.en.json';
import I18n, { formatI18n } from '../../../../I18n/I18n/I18n';
import { withAdditionalIntl } from '../../../../I18n/AdditionalIntl/AdditionalIntl';
import Modal from '../../../../Modal/Modal/Modal';
import ModalHeader from '../../../../Modal/ModalHeader/ModalHeader';
import ModalBody from '../../../../Modal/ModalBody/ModalBody';
import ModalFooter from '../../../../Modal/ModalFooter/ModalFooter';
import Button from '../../../../Buttons/Button/Button';
import ButtonLabel from '../../../../Buttons/ButtonLabel/ButtonLabel';
import ButtonGroup from '../../../../Buttons/ButtonGroup/ButtonGroup';
import ValidationForm from '../../../ValidationForm/ValidationForm';
import H from '../../../../H/H';
import ThemeContext from '../../../../ThemeContext';
var messages = normalizeLocaleData(en, '@dm/components.moveModal');
function getMoveItemSchema(minimum, maximum, currentPosition) {
  var rowNumber = {
    title: '@dm/components.moveModal.field',
    type: 'number',
    multipleOf: 1.0,
    minimum: minimum,
    maximum: maximum,
    not: {
      enum: [currentPosition]
    }
  };
  if (minimum === maximum) {
    rowNumber['default'] = minimum;
  }
  return {
    type: 'object',
    required: ['rowNumber'],
    properties: {
      rowNumber: rowNumber
    }
  };
}
function getMoveItemUiSchema(minimum, maximum) {
  return {
    rowNumber: {
      'ui:widget': 'text',
      'ui:readonly': minimum === maximum
    }
  };
}
function getTransformErrors(intl) {
  return function (errors) {
    return errors.map(function (error) {
      switch (error.name) {
        case 'minimum':
          error.message = intl.formatMessage({
            id: '@dm/components.moveModal.error.belowMinimum'
          }, {
            limit: error.params.limit
          });
          break;
        case 'maximum':
          error.message = intl.formatMessage({
            id: '@dm/components.moveModal.error.aboveMaximum'
          }, {
            limit: error.params.limit
          });
          break;
        case 'not':
          error.message = intl.formatMessage({
            id: '@dm/components.moveModal.error.isCurrent'
          });
          break;
        case 'type':
          error.message = intl.formatMessage({
            id: '@dm/components.moveModal.error.notANumber'
          });
          break;
        case 'multipleOf':
          error.message = intl.formatMessage({
            id: '@dm/components.moveModal.error.notANumber'
          });
          break;
      }
      return error;
    });
  };
}
var initialState = {
  isValid: false,
  formData: {},
  moveClicked: false,
  moveValidated: false
};
export var MoveModal = /*#__PURE__*/function (_React$Component) {
  _inherits(MoveModal, _React$Component);
  function MoveModal(props) {
    var _this;
    _classCallCheck(this, MoveModal);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(MoveModal).call(this, props));
    _this.messages = void 0;
    _this._submitRef = void 0;
    _this._titleId = void 0;
    _this.handleChange = function (formData) {
      _this.setState({
        formData: formData
      });
    };
    _this.handleValidate = function (isValid) {
      _this.setState(function (state) {
        return {
          isValid: isValid,
          moveValidated: state.moveClicked
        };
      });
    };
    _this.handleMove = function () {
      _this.setState({
        moveClicked: true
      });
    };
    _this.messages = normalizeLocaleData(en, '@dm/components.moveModal');
    _this.state = initialState;
    _this._submitRef = React.createRef();
    _this._titleId = uuid();
    return _this;
  }
  _createClass(MoveModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.moveValidated) {
        if (this.state.isValid && this.state.formData.rowNumber !== undefined) {
          this.props.onMove(this.state.formData.rowNumber - 1);
        } else {
          this.setState({
            moveClicked: false,
            moveValidated: false
          });
        }
      } else if (this.state.moveClicked) {
        this._submitRef.current.click();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var theme = this.context;
      var _this$props = this.props,
        items = _this$props.items,
        item = _this$props.item,
        itemI18n = _this$props.itemI18n,
        intl = _this$props.intl;
      var currentPosition = item.index + 1;
      var maxPosition = items.length === currentPosition ? items.length - 1 : items.length;
      var minPosition = currentPosition === 1 ? 2 : 1;
      if (minPosition === maxPosition && !this.state.isValid) {
        this.setState({
          isValid: true
        });
      }
      var moveSchema = getMoveItemSchema(minPosition, maxPosition, currentPosition);
      var moveUiSchema = getMoveItemUiSchema(minPosition, maxPosition);
      var messageIdSuffix = minPosition === maxPosition ? 'general' : 'limited';
      var titleI18n = {
        id: '@dm/components.moveModal.title',
        values: {
          itemText: formatI18n(intl, itemI18n)
        }
      };
      return /*#__PURE__*/React.createElement(Modal, {
        refocusEl: this.props.refocusEl,
        modifier: 'move-dsa-row',
        mounted: this.props.isShowing,
        maxWidth: '32em',
        titleId: this._titleId,
        onExit: this.props.onCancel,
        includeCloseX: true
      }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(H, {
        id: this._titleId
      }, /*#__PURE__*/React.createElement(I18n, {
        i18n: titleI18n
      }))), /*#__PURE__*/React.createElement(ModalBody, {
        alignment: "left"
      }, /*#__PURE__*/React.createElement("p", {
        className: "move-modal__instructional-text"
      }, /*#__PURE__*/React.createElement(I18n, {
        i18n: {
          id: "@dm/components.moveModal.".concat(messageIdSuffix),
          values: {
            minimum: minPosition,
            maximum: maxPosition
          }
        }
      })), /*#__PURE__*/React.createElement(ValidationForm, {
        size: 'large',
        schema: moveSchema,
        uiSchema: moveUiSchema,
        formData: this.state.formData,
        onChange: this.handleChange,
        liveValidate: true,
        onValidate: this.handleValidate,
        transformErrors: getTransformErrors(this.props.intl),
        submitRef: this._submitRef
      })), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
        className: "_dm-button",
        onClick: this.props.onCancel
      }, /*#__PURE__*/React.createElement(ButtonLabel, {
        i18nKey: "@dm/components.moveModal.cancel"
      })), /*#__PURE__*/React.createElement(Button, {
        className: "_dm-button",
        onClick: this.handleMove,
        disabled: !this.state.isValid,
        modifier: theme === 'ripple' ? 'primary' : undefined
      }, /*#__PURE__*/React.createElement(ButtonLabel, {
        i18nKey: "@dm/components.moveModal.confirm"
      })))));
    }
  }]);
  return MoveModal;
}(React.Component);
MoveModal.contextType = ThemeContext;
var enhanced = compose(withAdditionalIntl(messages), injectIntl)(MoveModal);
export default enhanced;